import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import moment from 'moment';

import { CsvBuilder } from 'filefy';

import TableView from '../Table/Table';

import { fetchDispute, addDispute, editDispute, fetchAllDisputes, fetchJournalTransactions, filteredData, setEdited, setModified, setDisputeID } from '../../../redux/actions/DisputeActions';


import { Button } from '@mui/material';
import { ModeEditOutlineRounded } from '@mui/icons-material';

// import Receipt from '../Receipt/Receipt';
import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';
import SweetAlert from 'react-bootstrap-sweetalert';


const DisputeList = (props) => {

    const [searchValue, setSearchValue] = useState('');

    const [disputeID, setDisputeID] = useState('');
    const [transactionDate, setTransactionDate] = useState(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'));
    const [processorTermID, setProcessorTermID] = useState('');
    const [seqNumber, setSeqNumber] = useState('');
    const [amount, setAmount] = useState('');
    const [pan, setPan] = useState('');
    const [submitBy, setSubmitBy] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [isSubmitted, setIsSubmitted] = useState(false);


    const [, setDisputeIDError] = useState(false);
    const [transactionDateError, setTransactionDateError] = useState(false);
    const [processorTermIDError, setProcessorTermIDError] = useState(false);
    const [seqNumberError, setSeqNumberError] = useState(false);
    const [amountError, setAmountError] = useState(false);
    const [panError, setPanError] = useState(false);
    const [submitByError, setSubmitByError] = useState(false);
    const [, setIsSubmittedError] = useState(false);

    const [addModelOpen, setAddModelOpen] = useState(false)
    const [journalDataModelOpen, setJournalDataModelOpen] = useState(false)

    const [journalTranData, setJournalTranData] = useState([])

    const [edit, setEdit] = useState(false)



    const handleChange = (event) => {

        let targetName = event.target.name;
        let targetValue = event.target.value;

        switch (targetName) {
            case 'disputeID':
                setDisputeIDError(false);
                setDisputeID(targetValue);
                break
            case 'transactionDate':
                setTransactionDateError(false);
                setTransactionDate(targetValue);
                break
            case 'processorTermID':
                setProcessorTermIDError(false);
                setProcessorTermID(targetValue);
                break
            case 'seqNumber':
                setSeqNumberError(false);
                setSeqNumber(targetValue);
                break
            case 'amount':
                setAmountError(false);
                setAmount(targetValue);
                break
            case 'pan':
                setPanError(false);
                setPan(targetValue);
                break
            case 'submitBy':
                setSubmitByError(false);
                setSubmitBy(targetValue);
                break
            case 'isSubmitted':
                setIsSubmittedError(false);
                setIsSubmitted(targetValue);
                break
            default:
                break
        }
    }

    const handleSubmit = () => {

        let body = {}

        if (processorTermID && processorTermID.trim()) {
            setProcessorTermIDError(false);
            body.processorTermID = processorTermID.trim()
        } else {
            setProcessorTermIDError(true)
        }

        if (transactionDate) {
            setTransactionDateError(false);
            body.transactionDate = new Date(transactionDate)
        } else {
            setTransactionDateError(true)
        }

        if (seqNumber) {
            setSeqNumberError(false);
            body.seqNumber = seqNumber
        } else {
            setSeqNumberError(true)
        }

        if (amount) {
            setAmountError(false);
            body.amount = amount
        } else {
            setAmountError(true)
        }

        if (pan) {
            setPanError(false);
            body.pan = pan
        } else {
            setPanError(true)
        }

        if (submitBy) {
            setSubmitByError(false);
            body.submitBy = submitBy
        } else {
            setSubmitByError(true)
        }

        if (pan) {
            setIsSubmittedError(false);
            body.isSubmitted = isSubmitted
        } else {
            setIsSubmittedError(true)
        }

        console.log('Body : ' + body.data)


        if (processorTermID && transactionDate && pan && seqNumber && amount && submitBy && !edit) {
            props.addDispute(body);
        } else if (processorTermID && transactionDate && pan && seqNumber && amount && submitBy && disputeID && edit) {
            body.disputeID = disputeID
            props.editDispute(body);
            props.setEdited(true);
            setAddModelOpen(false)
        }

    }

    const handleDownload = () => {

        props.fetchJournalTransactions(props.DISPUTEREDUCER.disputeID)

        setJournalTranData(props.DISPUTEREDUCER.disputeJournalData)
        console.log('Journal Data : ', props.DISPUTEREDUCER.disputeJournalData)
        setJournalDataModelOpen(true)

    }

    const handleEdit = (value) => {

        console.log('Value in edit : ' + value)
        setEdit(true)
        props.fetchDispute(value)
        setAddModelOpen(true)

    }

    const handleAdd = (value) => {
        handleReset()
        setAddModelOpen(true)
        setEdit(false)
    }


    const exportAllSelectedRows = () => {

        new CsvBuilder(props.DISPUTEREDUCER.disputeJournalData[0].processorTermID + "_Dispute.csv")
            .setColumns(heading.journalData.map(col => col.headerName))
            .addRows(props.DISPUTEREDUCER.disputeJournalData?.map(rowData => heading.journalData.map(col => rowData[col.field])))
            .exportFile();

    }

    const handleReset = () => {
        setDisputeID('')
        setProcessorTermID('')
        setTransactionDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))
        setSeqNumber('')
        setAmount('')
        setPan('')
        setSubmitBy(moment(new Date()).format('YYYY-MM-DD'))
        setIsSubmitted(false)

        setDisputeIDError(false)
        setProcessorTermIDError(false)
        setTransactionDateError(false)
        setSeqNumberError(false)
        setAmountError(false)
        setPanError(false)
        setSubmitByError(false)
        setIsSubmittedError(false)

    }



    useEffect(() => {
        props.fetchAllDisputes()
        props.setModified(false)
        props.filteredData()

        return () => {
            props.setEdited(false)
        }
    }, [])

    useEffect(() => {

        console.log('In Use Effect : ')
        if (props.DISPUTEREDUCER.disputeData) {
            setDisputeID(props.DISPUTEREDUCER.disputeData.disputeID)
            setProcessorTermID(props.DISPUTEREDUCER.disputeData.processorTermID)
            setTransactionDate(moment(props.DISPUTEREDUCER.disputeData.transactionDate).format('YYYY-MM-DD hh:mm:ss'))
            setSeqNumber(props.DISPUTEREDUCER.disputeData.seqNumber)
            setAmount(props.DISPUTEREDUCER.disputeData.amount)
            setPan(props.DISPUTEREDUCER.disputeData.pan)
            setSubmitBy(props.DISPUTEREDUCER.disputeData.submitBy)
            setIsSubmitted(props.DISPUTEREDUCER.disputeData.isSubmitted)
        }

    }, [props.DISPUTEREDUCER.disputeData])


    const handleClick = (value) => {
        setDisputeID(value.data.disputeID)
        props.setDisputeID(value.data.disputeID)
        console.log(value.data.disputeID)
    }

    const handleSearch = (event) => {
        setSearchValue(event.target.value)
        let filteredClients = event.target.value && event.target.value.length ? props.DISPUTEREDUCER.disputesData.filter(client => {
            if (client.processorTermID.toLowerCase().includes(event.target.value.toLowerCase())) {
                return client
            }
            return null
        }) : []

        props.filteredData(filteredClients)

    }

    const heading = {

        journalData: [

            {
                field: 'tranTime', tooltipField: 'transTime', headerName: 'Transaction Time', minWidth: 170, cellRenderer: function (params) {
                    return moment(params.value).format('MMM DD, YYYY HH:mm:ss');
                }
            },

            { field: 'processorTermID', tooltipField: 'processorTermID', headerName: 'Processor TID', minWidth: 120 },

            { field: 'termTime', tooltipField: 'termTime', headerName: 'Terminal Time' },

            { field: 'termDate', tooltipField: 'termDate', headerName: 'Term Date' },
            { field: 'settleDate', tooltipField: 'settleDate', headerName: 'Settle Date' },
            { field: 'tranType', tooltipField: 'tranType', headerName: 'Tran Type', minWidth: 170 },
            { field: 'seqNumber', tooltipField: 'seqNumber', headerName: 'PTID Seq#', minWidth: 120 },
            {
                field: 'amount', tooltipField: 'amount', headerName: 'Amount', cellRenderer: function (params) {
                    return "$" + params.data.amount
                },
            },
            {
                field: 'fee', tooltipField: 'fee', headerName: 'Fee', cellRenderer: function (params) {
                    return "$" + params.data.fee
                },
            },
            { field: 'cardNumber', tooltipField: 'cardNumber', headerName: 'Card Number' },
            { field: 'respCode', tooltipField: 'respCode', headerName: 'Response Code' },
            { field: 'respDesc', tooltipField: 'respDesc', headerName: 'Response Desc' },
            { field: 'termErrorCode', tooltipField: 'termErrorCode', headerName: 'Terminal Error Code' },
            { field: 'authCode', tooltipField: 'authCode', headerName: 'Authorization Code' },
            // "tranStatus": "0",
            // { field: 'seqNumber', tooltipField: 'seqNumber', headerName: 'Seq#' },
            { field: 'applicationID', tooltipField: 'applicationID', headerName: 'AID' },
            { field: 'terminalCapability', tooltipField: 'terminalCapability', headerName: 'Terminal Capability' },
            { field: 'posMode', tooltipField: 'posMode', headerName: 'POS Mode' },
            { field: 'terminalVerificationResult', tooltipField: 'terminalVerificationResult', headerName: 'Terminal Verification Result' },
            { field: 'requestCryptogram', tooltipField: 'requestCryptogram', headerName: 'Request Cryptogram' },
            { field: 'issuerAduthenticationData', tooltipField: 'issuerAduthenticationData', headerName: 'Issuer Authentication Data' },
            { field: 'acqResponseCode', tooltipField: 'acqResponseCode', headerName: 'Acquirer Response Code' },

        ],

        disputes: [
            {
                field: 'transactionDate', tooltipField: 'transactionDate', headerName: 'TransTime', minWidth: 150, maxWidth: 170, cellRenderer: function (params) {
                    return moment(params.value).format('MMM DD, YYYY HH:mm:ss');
                }
            },
            { field: 'processorTermID', tooltipField: 'processorTermID', headerName: 'P TID', minWidth: 120, maxWidth: 120 },
            { field: 'seqNumber', tooltipField: 'seqNumber', headerName: 'PTID Seq#', minWidth: 100, maxWidth: 100 },
            { field: 'pan', tooltipField: 'pan', headerName: 'PAN', minWidth: 90, maxWidth: 90 },
            {
                field: 'amount', tooltipField: 'amount', headerName: 'Amount', minWidth: 120, maxWidth: 120, cellRenderer: function (params) {
                    return "$" + params.data.amount
                },
            },
            {
                field: 'createDate', tooltipField: 'createDate', headerName: 'Create Date', minWidth: 240, cellRenderer: function (params) {
                    return params.value ? moment(params.value).format('MMM DD, YYYY HH:mm:ss') : "N/A";
                }
            },
            {
                field: 'transactionPresent', tooltipField: 'transactionPresent', headerName: 'Transaction Present', minWidth: 120, cellRenderer: function (params) {
                    return Number(params.value) === 1 ? 'Yes' : 'No'; // eslint-fix: preserve loose-equality coercion
                }
            },
            {
                field: 'Action', headerName: 'Action', minWidth: 80, cellRenderer: function (params) {
                    return <button className='btn btn-secondary d-block w-30 btn-xs fs-11px' onClick={handleDownload} disabled={!params.data.transactionPresent} color={"success"}> <h9>Get Journal Data</h9></button>
                }
            },
            {
                field: 'Edit', tooltipField: 'Edit', headerName: 'Edit', minWidth: 80, cellRenderer: function (params) {
                    return <Button size='small' onClick={() => handleEdit(params.data.disputeID)} color={"success"}> <ModeEditOutlineRounded /></Button>
                }
            },

        ],
    }

    let DISPUTE_FORM = (

        <p className="lead text-dark ">

            <SweetAlert
                showCancel
                confirmBtnText="Save"
                cancelBtnBsStyle="default"
                onConfirm={handleSubmit}
                onCancel={() => setAddModelOpen(false)}
            >

                <Panel >
                    <PanelHeader>ADD PROCESSOR TERMINAL FORM</PanelHeader>
                    <PanelBody>

                        <form className="fs-13px">

                            {/* <div className=""> */}

                            <div className="row gx-12">

                                <div className="col-md-12 mb-12 mb-md-2">
                                    <label className={"col-md-6 " + (processorTermIDError ? 'text-danger' : '')}><b>Processor Terminal ID</b></label>
                                    <input type="text"
                                        className="form-control fs-13px"
                                        name="processorTermID"
                                        onChange={handleChange}
                                        value={processorTermID ? processorTermID : ''}
                                    />
                                </div>


                                <div className="row gx-12">
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-6 " + (transactionDateError ? 'text-danger' : '')}><b>Tranaction Date</b></label>
                                        <input
                                            className="form-control fs-13px"
                                            type='datetime-local'
                                            onChange={handleChange}
                                            name='transactionDate'
                                            value={transactionDate ? transactionDate : ''}
                                        >
                                        </input>
                                    </div>
                                </div>
                                <div className="row gx-12">
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-6 " + (seqNumberError ? 'text-danger' : '')}><b>Sequence Number</b></label>
                                        <input
                                            className="form-control fs-13px"
                                            name="seqNumber"
                                            onChange={handleChange}
                                            size="small"
                                            value={seqNumber ? seqNumber : ''}
                                        >
                                        </input>
                                    </div>
                                </div>
                                <div className="row gx-12">
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-6 " + (amountError ? 'text-danger' : '')}><b>Amount</b></label>
                                        <input
                                            className="form-control fs-13px"
                                            name="amount"
                                            onChange={handleChange}
                                            value={amount ? amount : ''}
                                            error={amountError}
                                        >
                                        </input>
                                    </div>
                                </div>
                                <div className="row gx-12">
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-6 " + (panError ? 'text-danger' : '')}><b>PAN Last4</b></label>
                                        <input
                                            className="form-control fs-13px"
                                            name="pan"
                                            onChange={handleChange}
                                            size="small"
                                            value={pan ? pan : ''}
                                            error={panError}
                                        >
                                        </input>
                                    </div>
                                </div>
                                <div className="row gx-12">
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-6 " + (submitByError ? 'text-danger' : '')}><b>Submit By</b></label>
                                        <input
                                            className="form-control fs-13px"
                                            name="submitBy"
                                            onChange={handleChange}
                                            size="small"
                                            // defaultValue={moment(new Date()).format('YYYY-MM-DD')}
                                            value={submitBy ? submitBy : ''}
                                            error={submitByError}
                                        >
                                        </input>
                                    </div>
                                </div>


                                {/* <Grid item xs={6} sm={6} md={6}>
                                    {edit ? <Button fullWidth className="form-button" variant='contained' onClick={handleDisputeAddEditModelClose}>Cancel</Button>
                                        : <Button fullWidth className="form-button" onClick={handleReset} variant='contained' >Reset</Button>}
                                </Grid>
                                <Grid item xs={6} sm={6} md={6}>
                                    <Button fullWidth onClick={handleSubmit} variant='contained' >{edit ? 'Save' : 'Add'}</Button>
                                </Grid> */}

                                {/* </div> */}
                            </div>

                        </form>

                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p>


    )


    let JOURNAL_DATA_FORM = (

        <div>

        <p className="lead text-dark ">
            <SweetAlert
                showCancel
                confirmBtnText="Add"
                cancelBtnBsStyle="default"
                onConfirm={exportAllSelectedRows}
                onCancel={() => setJournalDataModelOpen(false)}
                fullWidth
                width="100%"
                >
                <Panel >
                    <PanelHeader><b>JOURNAL DATA - {journalTranData[0]?.processorTermID}</b></PanelHeader>
                    <TableView height={360} count={7} headings={heading.journalData} data={props.DISPUTEREDUCER.disputeJournalData} />
                </Panel>
            </SweetAlert>
        </p>
                </div>

    )


    return (




        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-8">
                        <h4>Disputes</h4>
                    </div>
                    <div className="col-xl-2">
                        <input type="text" className="form-control" placeholder="Search..." onChange={handleSearch} />
                    </div>
                    <div className="col-xl-2">
                        {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? // eslint-fix: preserve loose-equality coercion
                            <button className="btn btn-sm btn-secondary d-block btn-lg h-35px fs-09px" onClick={handleAdd}>Add Dispute</button>
                            : null}
                    </div>
                </div>
            </PanelHeader>
            {/* <PanelBody> */}
            <TableView height={545} headings={heading.disputes} data={(props.DISPUTEREDUCER.filteredData && props.DISPUTEREDUCER.filteredData.length) || searchValue ? props.DISPUTEREDUCER.filteredData : props.DISPUTEREDUCER.disputesData} handleClick={handleClick} />
            {addModelOpen ? DISPUTE_FORM : null}
            {journalDataModelOpen ? JOURNAL_DATA_FORM : null}
            {/* {receiptModelOpen ? VIEW_RECEIPT : null} */}

            {/* </PanelBody> */}
        </Panel>
    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchDispute,
    addDispute,
    editDispute,
    fetchAllDisputes,
    fetchJournalTransactions,
    filteredData,
    setEdited,
    setModified,
    setDisputeID
}


export default connect(mapStateToProps, mapDispatchToProps)(DisputeList);